import * as React from "react"
import { Container, Modal, Row, Col, Button, Form } from "react-bootstrap"
import { toast } from "react-toastify"
import { Subscription } from "rxjs"
import { APIError } from "../../api/ObservableFromFetch"
import EventExcuseObservable from "../../api/Randoms/EventExcuse"
import SelectionInboxGridRow from "../../api/Randoms/SelectionInboxModel/SelectionInboxGridRow"
import ConfirmationModal from "../ConfirmationModal"

interface QueryNameModalProps {
  show: boolean
  onSave: (name: string) => void
  onClose: () => void
}

interface QueryNameModalState {
  comment: string
  saving: boolean
}

export default class QueryNameModal extends React.PureComponent<QueryNameModalProps, {}> {
  state: QueryNameModalState = { comment: "", saving: false }
  subscription?: Subscription

  componentWillUnmount() {
    this.subscription && this.subscription.unsubscribe()
  }

  handleAPIError = (error: Error | APIError, stateChanges: object) => {
    this.setState(stateChanges)
    error && toast.error((error as APIError)?.errorData?.message || error.message)
  }
  
  handleConfirm = () => {
    this.props.onSave(this.state.comment.trim())
  }

  render() {
    return <ConfirmationModal show={this.props.show}
      title="Save Query"
      confirmButtonText="Save"
      onConfirm={this.handleConfirm}
      onHide={() => this.props.onClose()}
      size="lg"
      disableConfirmButton={this.state.comment.trim().length === 0}
      spinConfirmButton={this.state.saving}
      disableConfirmOnSpin={true}>
      <Form>
        <Form.Row className="form-group required">
          <Form.Label column lg={3} htmlFor="comment">Enter query name</Form.Label>
          <Col lg={9}>
            <Form.Control
              id="comment"
              type="text"
              value={this.state.comment}
              onChange={e => this.setState({ comment: e.target.value })} />
          </Col>
        </Form.Row>
      </Form>
    </ConfirmationModal>
  }
}